// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_1uEwN","status":"index_status_1KQwH","footer":"index_footer__vdOc"};